export default __webpack_public_path__ + "static/media/market1.64214f50.svg";